import React from "react";
import { CircularProgress, Switch } from "@mui/material";
import {
  NotificationsActiveOutlined,
  NotificationsOffOutlined,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import color from "../../Constants/colors";
import { usePushNotifications } from "../../Hooks/usePushNotifications";
import { SettingRow } from "./ProfileSection";

const PushNotificationSettings: React.FC = () => {
  const { t } = useTranslation("profile");
  const { supported, subscribed, blocked, loading, enable, disable } =
    usePushNotifications();

  if (!supported) return null;

  const statusKey = blocked
    ? "profile.pushStatusBlocked"
    : subscribed
      ? "profile.pushStatusOn"
      : "profile.pushStatusOff";

  return (
    <SettingRow
      icon={
        subscribed ? (
          <NotificationsActiveOutlined />
        ) : (
          <NotificationsOffOutlined />
        )
      }
      title={t("profile.pushTitle")}
      description={t(statusKey)}
      action={
        <>
          {loading && (
            <CircularProgress size={16} sx={{ color: color.gray400 }} />
          )}
          <Switch
            checked={subscribed}
            onChange={() => (subscribed ? disable() : enable())}
            disabled={loading || blocked}
            inputProps={{
              "aria-label": subscribed
                ? t("profile.pushDisable")
                : t("profile.pushEnable"),
            }}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": { color: color.white },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: color.accent,
                opacity: 1,
              },
              "& .MuiSwitch-track": { backgroundColor: color.gray400 },
            }}
          />
        </>
      }
    />
  );
};

export default PushNotificationSettings;
